import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VkCardComponent } from '@shared/components/vk-card/componentns/vk-card/vk-card.component';
import { SvgModule } from '@shared/components/svg/svg.module';
import { MapModule } from '@shared/components/map/map.module';
import { TranslateModule } from '@ngx-translate/core';
import { NgLetModule } from '@shared/directives/ng-let/ng-let.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CustomToolTipModule } from '@shared/directives/custom-tool-tip/custom-tool-tip.module';
import { VkPollComponent } from './componentns/vk-poll/vk-poll.component';
import { PollFillPipe } from './pipes/poll-fill.pipe';
import { VkPostBtnTextPipe } from './pipes/vk-post-btn-text.pipe';

@NgModule({
  declarations: [VkCardComponent, VkPollComponent, PollFillPipe, VkPostBtnTextPipe],
  imports: [CommonModule, SvgModule, MapModule, TranslateModule, NgLetModule, MatTooltipModule, CustomToolTipModule],
  exports: [VkCardComponent]
})
export class VkCardModule {}
